<template>
    <div
        class="row from-mobile-header edit-row"
        v-if="show">
        <div class="pt-2"
             :class="col">
            <b-icon-display class="text-danger"/>
            <span class="ml-1">Active info</span>
        </div>

        <div class="from-mobile mobile-header-wrapper" :class="columns.length > 1 ? 'mobile-header-multi' : 'col'">
            <div v-if="columns.length === 0" class="mobile-header-cell">
                <b-icon-phone class="text-danger"/>
                <span class="ml-1">Mobile added info</span>
            </div>
            <div v-for="userColumn in columns" :key="userColumn.userId"
                 class="mobile-header-cell" :class="{ 'has-divider': columns.length > 1 }">
                <div><b-icon-phone class="text-danger"/><span class="ml-1">{{ userColumn.userName }}{{ userColumn.uniqueId ? ' (' + userColumn.uniqueId + ')' : '' }}</span></div>
                <small v-if="userColumn.latestAt" class="text-muted d-block">Last sync on: {{ formatDate(userColumn.latestAt) }}</small>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MobileHeaderInfo',

    props: {
        show: {
            type: Boolean,
            default: false
        },
        col: {
            type: String,
            default: 'col-sm-8'
        },
        columns: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        formatDate(date) {
            return date ? this.$options.filters.moment(date, 'DD.MM.YYYY HH:mm') : '';
        }
    }
}
</script>

<style scoped>
.mobile-header-wrapper:not(.mobile-header-multi) {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.mobile-header-multi {
    display: block;
    white-space: nowrap;
    flex: 0 0 auto;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.mobile-header-multi .mobile-header-cell {
    display: inline-block !important;
    box-sizing: border-box !important;
    width: 265px !important;
    padding: 0 8px !important;
    margin: 0 !important;
    vertical-align: top;
    white-space: normal;
}

.mobile-header-cell {
    text-align: center;
}

.mobile-header-cell.has-divider {
    border-left: 1px solid rgba(0, 0, 0, 0.2);
}

.mobile-header-cell.has-divider:first-child {
    border-left: none;
}
</style>
